export interface BoundaryTextPart {
  text: string;
  position?: number;
  start: number;
  end: number;
}

const isBoundarySkippableText = (text: string): boolean =>
  /^[\s()[\]{}"'“”‘’.,;:!?¿¡\-—–…]*$/.test(text);

/**
 * Given a text offset within the synthesized string, returns the position of
 * the text part that contains it. If the offset lands on punctuation just
 * before a positioned word, returns that next word's position.
 */
export const boundaryOffsetToPosition = (
  parts: BoundaryTextPart[],
  textOffset: number
): number | undefined => {
  const part = parts.find(
    (candidate) => candidate.start <= textOffset && textOffset < candidate.end
  );
  if (part?.position !== undefined) return part.position;

  let skippedText = "";
  for (const candidate of parts.filter(
    (partToCheck) => partToCheck.end > textOffset
  )) {
    if (candidate.position !== undefined) {
      if (
        candidate.start >= textOffset &&
        isBoundarySkippableText(skippedText)
      ) {
        return candidate.position;
      }
      return undefined;
    }

    skippedText += candidate.text.slice(
      Math.max(0, textOffset - candidate.start)
    );
    if (!isBoundarySkippableText(skippedText)) return undefined;
  }

  return undefined;
};
